import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import DetailsWrapper from '../Details/DetailsWrapper';
import { useTranslation } from 'react-i18next';
import { mapOmekaMediaMetadata } from '../../pages/ΟΑ/Tekmirio/helperFunctions';
import { _tekmirioFiles } from '../../lib/static/oa/tekmirio/details';
import { mapByRefValue } from '../Details/Details';

interface IMediaSlides {
    url: string;
    thumbnail: string;
    title?: string;
    type?: string;
    mediaId?: number;
}
interface IMobileCarousel {
    slides?: IMediaSlides[] | any;
    media?: any;
    fileInfo?: boolean;
}

export default function MobileCarousel({slides, media, fileInfo=false}: IMobileCarousel) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [mediaMetadata, setMediaMetadata] = React.useState<any[]>([]);
  const maxSteps = slides.length;
  const { t } = useTranslation();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
 
  React.useEffect(() => {
    const mediaWithInfo = mapOmekaMediaMetadata(media, slides[activeStep].mediaId);
    const detailsFormatTransform = mapByRefValue(mediaWithInfo, _tekmirioFiles);
    setMediaMetadata(detailsFormatTransform);
  }, [activeStep]);

  return (
    <>
      <Box sx={{display: 'flex', justifyContent: 'center'}}>    
        <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
          <Paper
            square
            elevation={0}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 50,
              pl: 2,
              bgcolor: 'transparent',
            }}
          >
          </Paper>
          <Box
            component='img'
            sx={{
              height: 255,
              display: 'flex',
              maxWidth: 400,
              overflow: 'hidden',
              width: '100%',
              objectFit: 'contain'
            }}
            src={slides[activeStep].url}
            alt={slides[activeStep].title}
          />
          <MobileStepper
            sx={{backgroundColor: 'transparent'}}
            variant='text'
            steps={maxSteps}
            position='static'
            activeStep={activeStep}
            nextButton={
              <Button
                size='small'
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                {theme.direction === 'rtl'
                  ? (
                    <KeyboardArrowLeft />
                  )
                  : (
                    <KeyboardArrowRight />
                  )}
              </Button>
            }
            backButton={
              <Button size='small' onClick={handleBack}
                disabled={activeStep === 0}>
                {theme.direction === 'rtl'
                  ? (
                    <KeyboardArrowRight />
                  )
                  : (
                    <KeyboardArrowLeft />
                  )}
              </Button>
            }
          />
        </Box>
      </Box>
      {fileInfo &&
      <DetailsWrapper
        title={t('Λεπτομέρειες Αρχείου')}
        detailsProps={{
          rows: mediaMetadata.map((x: any)=>{
            return {
              ...x, name: t(x.name)
            };
          }),
          removeLines: true
        }}
      />}
    </>
  );
}
